export const artifacts = () => ({
    collection: () => `/artifacts`,
    single: (artifact_type?: string) => ({
        breakdown: `/artifacts/breakdown`,
        metadata: (token_id: string) => `/artifacts/${artifact_type}/${token_id}/metadata`,
        generateSignature: (token: string) => `/artifacts/${artifact_type}/${token}/generate_signature`,
    }),
    artifactTypesMeta: () => `/artifacts/artifact_types/metadata`,
});
